module.exports = __webpack_public_path__ + "a2e01fc5d7eb5302729b843d4706b364.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/plugin/images/liebao.png
// module id = 907
// module chunks = 3